import { errMsg } from "./xutil";

export const payErr = (t, e) => {
  const d = e?.response?.data?.detail;
  const key = `x.pay.err.${d}`;
  const txt = typeof d === "string" ? t(key) : key;
  return txt === key ? errMsg(t, e) : txt;
};

export const STATUS_CLS = {
  pending: "bg-amber-100 text-amber-800", paid: "bg-brand/25 text-navy", failed: "bg-rose-100 text-rose-700",
  refunded: "bg-sky-100 text-sky-800", expired: "bg-slate-100 text-slate-600",
};

export const newKey = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
